<template>
  <v-app>
    <div id="app" :style="createCSS_var">
      <!-- <app-header></app-header> -->
      <router-view></router-view>
    </div>
    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
import JS from './JsonService'
import JK from './JsonKey'
import globalVar from './GlobalVar.js'
// import $ from 'jquery'
import Templates from './Templates'
import VersionDialog from '../src/VersionNotMatchDialog'

export default {
  name: 'App',
  components: {
    VersionDialog
  },
  // metaInfo() {
  //   return {
  //     title: 'e-Odering',
  //     meta: [
  //       { charset: 'utf-8' },
  //       {
  //         name: 'viewport',
  //         content: 'width=device-width, initial-scale=1.0'
  //       },
  //       {
  //         name: 'description',
  //         content: 'Welcome to eOrder!'
  //       },
  //       {
  //         property: 'og:title',
  //         content: 'eOrder'
  //       },
  //       {
  //         property: 'og:type',
  //         content: 'website'
  //       },
  //       {
  //         property: 'og:description',
  //         content: 'Welcome to eOrder!'
  //       },
  //       {
  //         property: 'og:image',
  //         content: this.tabLogo
  //       }
  //     ],
  //     link: [{ rel: 'icon', href: this.tabLogo }]
  //   }
  // },
  data() {
    return {
      versionError: false,
      tabLogo: ''
      //render: false
    }
  },
  computed: {
    createCSS_var() {
      return {
        '--header-eMsg-margin': this.getHeaderCSSwith('eMsg', 'margin'),
        '--header-eMsg-margin_top': this.getHeaderCSSwith('eMsg', 'margin_top'),
        '--header-eMsg-color': this.getHeaderCSSwith('eMsg', 'color'),
        '--header-eMsg-font_size': this.getHeaderCSSwith('eMsg', 'font_size'),

        '--header-h2-text_align': this.getHeaderCSSwith('h2', 'text_align'),
        '--header-h2-font_size': this.getHeaderCSSwith('h2', 'font_size'),

        // '--header-col_md_6-background_color': this.getHeaderCSSwith(
        //   'col_md_6',
        //   'background_color'
        // ),
        // '--header-col_md_6-border_radius': this.getHeaderCSSwith(
        //   'col_md_6',
        //   'border_radius'
        // ),

        '--header-mediaMax550-button_btn-padding_left': this.getHeaderCSSwith(
          'mediaMax550__button_btn',
          'padding_left'
        ),
        '--header-mediaMax550-button_btn-padding_right': this.getHeaderCSSwith(
          'mediaMax550__button_btn',
          'padding_right'
        ),

        '--header-mediaMax550-eMsg-margin': this.getHeaderCSSwith(
          'mediaMax550__eMsg',
          'margin'
        ),
        '--header-mediaMax550-eMsg-margin_top': this.getHeaderCSSwith(
          'mediaMax550__eMsg',
          'margin_top'
        ),
        '--header-mediaMax550-eMsg-color': this.getHeaderCSSwith(
          'mediaMax550__eMsg',
          'color'
        ),
        '--header-mediaMax550-eMsg-font_size': this.getHeaderCSSwith(
          'mediaMax550__eMsg',
          'font_size'
        ),
        '--header-mediaMax550-eMsg-margin_left': this.getHeaderCSSwith(
          'mediaMax550__eMsg',
          'margin_left'
        ),
        '--header-mediaMax550-eMsg-margin_right': this.getHeaderCSSwith(
          'mediaMax550__eMsg',
          'margin_right'
        ),

        '--login-eMsg-margin': this.getLoginCSSwith('eMsg', 'margin'),
        '--login-eMsg-margin_top': this.getLoginCSSwith('eMsg', 'margin_top'),
        '--login-eMsg-color': this.getLoginCSSwith('eMsg', 'color'),
        '--login-eMsg-font_size': this.getLoginCSSwith('eMsg', 'font_size'),

        '--login-h4-text_align': this.getLoginCSSwith('h4', 'text_align'),

        '--login-col_md_6-background_color': this.getLoginCSSwith(
          'col_md_6',
          'background_color'
        ),
        '--login-col_md_6-border_radius': this.getLoginCSSwith(
          'col_md_6',
          'border_radius'
        ),

        '--login-mediaMax550-button_btn-padding_left': this.getLoginCSSwith(
          'mediaMax550__button_btn',
          'padding_left'
        ),
        '--login-mediaMax550-button_btn-padding_right': this.getLoginCSSwith(
          'mediaMax550__button_btn',
          'padding_right'
        ),

        '--login-mediaMax550-eMsg-margin': this.getLoginCSSwith(
          'mediaMax550__eMsg',
          'margin'
        ),
        '--login-mediaMax550-eMsg-margin_top': this.getLoginCSSwith(
          'mediaMax550__eMsg',
          'margin_top'
        ),
        '--login-mediaMax550-eMsg-color': this.getLoginCSSwith(
          'mediaMax550__eMsg',
          'color'
        ),
        '--login-mediaMax550-eMsg-font_size': this.getLoginCSSwith(
          'mediaMax550__eMsg',
          'font_size'
        ),
        '--login-mediaMax550-eMsg-margin_left': this.getLoginCSSwith(
          'mediaMax550__eMsg',
          'margin_left'
        ),
        '--login-mediaMax550-eMsg-margin_right': this.getLoginCSSwith(
          'mediaMax550__eMsg',
          'margin_right'
        ),

        '--mainList-badgeQty-background_color': this.getMainListCSSwith(
          'badgeQty',
          'background_color'
        ),
        '--mainList-itemPriceColor-color': this.getMainListCSSwith(
          'itemPriceColor',
          'color'
        ),

        '--mainList-iPrice-width': this.getMainListCSSwith('iPrice', 'width'),
        '--mainList-iPrice-padding_left': this.getMainListCSSwith(
          'iPrice',
          'padding_left'
        ),
        '--mainList-iPrice-padding_right': this.getMainListCSSwith(
          'iPrice',
          'padding_right'
        ),

        '--mainList-border-padding': this.getMainListCSSwith(
          'border',
          'padding'
        ),
        '--mainList-border-border': this.getMainListCSSwith('border', 'border'),
        '--mainList-border-border_radius': this.getMainListCSSwith(
          'border',
          'border_radius'
        ),

        '--mainList-qtyBtn-position': this.getMainListCSSwith(
          'qtyBtn',
          'position'
        ),
        '--mainList-qtyBtn-background_color': this.getMainListCSSwith(
          'qtyBtn',
          'background_color'
        ),
        '--mainList-qtyBtn-border_radius': this.getMainListCSSwith(
          'qtyBtn',
          'border_radius'
        ),
        '--mainList-qtyBtn-top': this.getMainListCSSwith('qtyBtn', 'top'),
        '--mainList-qtyBtn-right': this.getMainListCSSwith('qtyBtn', 'right'),
        '--mainList-qtyBtn-width': this.getMainListCSSwith('qtyBtn', 'width'),
        '--mainList-qtyBtn-height': this.getMainListCSSwith('qtyBtn', 'height'),
        '--mainList-qtyBtn-padding': this.getMainListCSSwith(
          'qtyBtn',
          'padding'
        ),

        '--mainList-deleteBtn-position': this.getMainListCSSwith(
          'deleteBtn',
          'position'
        ),
        '--mainList-deleteBtn-top': this.getMainListCSSwith('deleteBtn', 'top'),
        '--mainList-deleteBtn-right': this.getMainListCSSwith(
          'deleteBtn',
          'right'
        ),
        '--mainList-deleteBtn-width': this.getMainListCSSwith(
          'deleteBtn',
          'width'
        ),
        '--mainList-deleteBtn-height': this.getMainListCSSwith(
          'deleteBtn',
          'height'
        ),
        '--mainList-deleteBtn-padding': this.getMainListCSSwith(
          'deleteBtn',
          'padding'
        ),

        // '--mainList-fix-position': this.getMainListCSSwith('fix', 'position'),
        '--mainList-fix-bottom': this.getMainListCSSwith('fix', 'bottom'),
        '--mainList-fix-background_color': this.getMainListCSSwith(
          'fix',
          'background_color'
        ),

        '--mainList-totalPayment-margin_top': this.getMainListCSSwith(
          'totalPayment',
          'margin_top'
        ),

        '--mainList-mediaMax450-totalPayment-font_size': this.getMainListCSSwith(
          'mediaMax450__totalPayment',
          'font_size'
        ),
        '--mainList-mediaMax450-totalPayment-margin_top': this.getMainListCSSwith(
          'mediaMax450__totalPayment',
          'margin_top'
        ),

        '--mainList-mediaMax450-h3-font_size': this.getMainListCSSwith(
          'mediaMax450__h3',
          'font_size'
        ),

        '--mainList-mediaMax450-h4-font_size': this.getMainListCSSwith(
          'mediaMax450__h4',
          'font_size'
        ),

        '--mainList-mediaMax450-SCText-font_size': this.getMainListCSSwith(
          'mediaMax450__SCText',
          'font_size'
        ),

        '--register-errorMsg-margin': this.getRegisterCSSwith(
          'errorMsg',
          'margin'
        ),
        '--register-errorMsg-margin_top': this.getRegisterCSSwith(
          'errorMsg',
          'margin_top'
        ),
        '--register-errorMsg-color': this.getRegisterCSSwith(
          'errorMsg',
          'color'
        ),
        '--register-errorMsg-font_size': this.getRegisterCSSwith(
          'errorMsg',
          'font_size'
        ),

        '--register-h4-text_align': this.getRegisterCSSwith('h4', 'text_align'),

        '--register-col_md_6-background_color': this.getRegisterCSSwith(
          'col_md_6',
          'background_color'
        ),
        '--register-col_md_6-border_radius': this.getRegisterCSSwith(
          'col_md_6',
          'border_radius'
        ),

        '--register-mediaMax550-button_btn-padding_left': this.getRegisterCSSwith(
          'mediaMax550__button_btn',
          'padding_left'
        ),
        '--register-mediaMax550-button_btn-padding_right': this.getRegisterCSSwith(
          'mediaMax550__button_btn',
          'padding_right'
        ),

        '--register-mediaMax550-errorMsg-margin': this.getRegisterCSSwith(
          'mediaMax550__errorMsg',
          'margin'
        ),
        '--register-mediaMax550-errorMsg-margin_top': this.getRegisterCSSwith(
          'mediaMax550__errorMsg',
          'margin_top'
        ),
        '--register-mediaMax550-errorMsg-color': this.getRegisterCSSwith(
          'mediaMax550__errorMsg',
          'color'
        ),
        '--register-mediaMax550-errorMsg-font_size': this.getRegisterCSSwith(
          'mediaMax550__errorMsg',
          'font_size'
        ),
        '--register-mediaMax550-errorMsg-margin_left': this.getRegisterCSSwith(
          'mediaMax550__errorMsg',
          'margin_left'
        ),
        '--register-mediaMax550-errorMsg-margin_right': this.getRegisterCSSwith(
          'mediaMax550__errorMsg',
          'margin_right'
        ),

        '--search-tablenUMInput-border': this.getSearchCSSwith(
          'tablenUMInput',
          'border'
        ),
        '--search-startOrderBtn-background_color': this.getSearchCSSwith(
          'startOrderBtn',
          'background_color'
        ),
        '--search-startOrderBtn-color': this.getSearchCSSwith(
          'startOrderBtn',
          'color'
        ),

        '--search-typeBtnSize-selectedType-background_color': this.getSearchCSSwith(
          'typeBtnSize_selectedType',
          'background_color'
        ),
        '--search-typeBtnSize-selectedType-color': this.getSearchCSSwith(
          'typeBtnSize_selectedType',
          'color'
        ),

        '--search-searchTxt-font_size': this.getSearchCSSwith(
          'searchTxt',
          'font_size'
        ),

        '--search-h3-text_align': this.getSearchCSSwith('h3', 'text_align'),

        '--search-bCol-padding': this.getSearchCSSwith('bCol', 'padding'),
        '--search-bCol-height': this.getSearchCSSwith('bCol', 'height'),

        '--search-bImg-width': this.getSearchCSSwith('bImg', 'width'),
        '--search-bImg-height': this.getSearchCSSwith('bImg', 'height'),
        '--search-bImg-padding': this.getSearchCSSwith('bImg', 'padding'),
        '--search-bImg-object_fit': this.getSearchCSSwith('bImg', 'object_fit'),

        '--search-col_md_4-float': this.getSearchCSSwith('col_md_4', 'float'),
        '--search-col_md_4-background_color': this.getSearchCSSwith(
          'col_md_4',
          'background_color'
        ),
        '--search-col_md_4-border_radius': this.getSearchCSSwith(
          'col_md_4',
          'border_radius'
        ),

        '--search-label-font_size': this.getSearchCSSwith('label', 'font_size'),

        '--search-mediaMax1200-label-font_size': this.getSearchCSSwith(
          'mediaMax1200__label',
          'font_size'
        ),

        // '--search-setColHgh-margin_bottom': this.getSearchCSSwith(
        //   'setColHgh',
        //   'margin_bottom'
        // ),

        // '--search-setColHgh2-margin_bottom': this.getSearchCSSwith(
        //   'setColHgh2',
        //   'margin_bottom'
        // ),

        '--search-mediaMax450-h3-font_size': this.getSearchCSSwith(
          'mediaMax450__h3',
          'font_size'
        ),
        '--search-mediaMax450-h4-font_size': this.getSearchCSSwith(
          'mediaMax450__h4',
          'font_size'
        ),

        '--search-mediaMax995-bImg-height': this.getSearchCSSwith(
          'mediaMax995__bImg',
          'height'
        ),

        '--shoppingCart-iPrice-width': this.getShoppingCartCSSwith(
          'iPrice',
          'width'
        ),
        '--shoppingCart-iPrice-padding_left': this.getShoppingCartCSSwith(
          'iPrice',
          'padding_left'
        ),
        '--shoppingCart-iPrice-padding_right': this.getShoppingCartCSSwith(
          'iPrice',
          'padding_right'
        ),

        '--shoppingCart-border-padding': this.getShoppingCartCSSwith(
          'border',
          'padding'
        ),
        '--shoppingCart-border-border': this.getShoppingCartCSSwith(
          'border',
          'border'
        ),
        '--shoppingCart-border-border_radius': this.getShoppingCartCSSwith(
          'border',
          'border_radius'
        ),

        '--shoppingCart-h2-font': this.getShoppingCartCSSwith('h2', 'font'),
        '--shoppingCart-txtClrRed-color': this.getShoppingCartCSSwith(
          'txtClrRed',
          'color'
        )
      }
    }
  },
  created() {
    sessionStorage.setItem('version', globalVar.version)
    this.getConfigData()
    this.getCSS()
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    getConfigData() {
      let dataPromise = new Promise(resolve => {
        let self = this
        fetch('/config.json')
          .then(res => res.json())
          .then(json => {
            self.configData = JSON.stringify(json)
            //console.log('getJsonData.json : ' + self.configData)
            sessionStorage.setItem('configData', self.configData)
            console.log(self.configData)
            resolve(self.configData)
          })
      })

      dataPromise.then(Msg => {
        if (JSON.parse(Msg).baseURLApi) {
          this.getCSS()
        }
      })
    },
    getHeaderCSSwith(obj, key) {
      return this.$store.state.svrCSS['header'][obj][key]
    },
    getLoginCSSwith(obj, key) {
      return this.$store.state.svrCSS['login'][obj][key]
    },
    getMainListCSSwith(obj, key) {
      return this.$store.state.svrCSS['mainList'][obj][key]
    },
    getRegisterCSSwith(obj, key) {
      return this.$store.state.svrCSS['register'][obj][key]
    },
    getSearchCSSwith(obj, key) {
      return this.$store.state.svrCSS['search'][obj][key]
    },
    getShoppingCartCSSwith(obj, key) {
      return this.$store.state.svrCSS['shoppingCart'][obj][key]
    },
    getCSS() {
      this.versionError = false
      this.$store.dispatch('updateCSS', Templates.temp1)
      let domainName
      if (globalVar.mode == 'normal') {
        domainName = window.location.hostname
        // //For Testing
        if (globalVar.state == 'test') {
          if (
            domainName == 'localhost' ||
            domainName == '192.168.0.150' ||
            domainName == '192.168.0.193'
          ) {
            //domainName = 'beizhan.mpos.us'
            domainName = 'demo.mpos.us'
            //domainName = 'test.mpos.us'
            //domainName = 'p9.mpos.us'
            //domainName = 'dtank.mpos.us'
          }
        }
      } else if (globalVar.mode == 'lite') {
        if (sessionStorage.getItem('paramMchdCode')) {
          domainName = sessionStorage.getItem('paramMchdCode')
        } else {
          domainName = window.location.pathname
          domainName = domainName.substr(1)
        }
      }
      console.log('domainName: ', domainName)

      if (sessionStorage.getItem('configData')) {
        var version = sessionStorage.getItem('version')
        let url = 'Order/GetInitList'
        let para = {
          [JK.AppVersion]: version,
          [JK.URL]: domainName
        }
        console.log(para)

        JS.request(url, para)
          .then(res => {
            console.log('res', res)
            if (
              res.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
              res.data == 'Version Not Match'
            ) {
              this.versionError = true
            } else {
              this.versionError = false
              if (res.data == 'This page no longer available') {
                this.$router.replace({
                  name: 'noLongerAvlb',
                  params: { mchdCode: domainName }
                })
              }
              if (res.data.ListOfMchtInfo[0].mv != null) {
                this.tabLogo = JS.checkImg(res.data.ListOfMchtInfo[0].mv)
              }
              // $(document).ready(function() {
              //   $('meta[property="og:image"]').attr('content', this.tabLogo)
              // })
              //alert(this.tabLogo)

              let json = res.data

              // console.log('json: ', json)

              let name = json.ListOfMchtInfo[0][JK.TempleteUrl] //'temp1'
              if (name != 'temp1' && name != 'temp2') {
                name = 'temp1'
              }
              let temp = Templates[name]
              console.log('tempName: ', name)
              console.log('temp', temp)
              if (temp !== 'underfined') {
                this.$store.dispatch('updateCSS', temp)
                console.log(this.$store.dispatch('updateCSS', temp))
                //this.render = true
              }
              sessionStorage.setItem(
                'SchdTypeBtnName',
                JSON.stringify({
                  DineIn: res.data.ListOfMchtInfo[0].se,
                  TakeAway: res.data.ListOfMchtInfo[0].sf,
                  Delivery: res.data.ListOfMchtInfo[0].sg,
                  ScanOrder: res.data.ListOfMchtInfo[0].si
                })
              )
              sessionStorage.setItem('NoItemMsg', res.data.ListOfMchtInfo[0].sh)
            }
          })
          .catch(err => {
            console.log('err', err)
            this.versionError = false
            //alert(err)
            //this.$store.dispatch('updateCSS', Templates.temp1)
          })
      } else {
        let name = 'temp1'
        let temp = Templates[name]
        console.log('tempName: ', name)
        console.log('temp', temp)
        if (temp !== 'underfined') {
          this.$store.dispatch('updateCSS', temp)
          console.log(this.$store.dispatch('updateCSS', temp))
          //this.render = true
        }
      }
    }
  }
}
</script>

<style>
#app {
  /* font-family: Times, Sans-serif, Roboto, Arial, Georgia; */
  font-family: Roboto-Regular, 'Helvetica Neue', Helvetica, Tahoma, Arial,
    Sans-serif;
}
</style>
